import axios from 'axios'
const token = "1551094d-975e-4fec-8c6a-c37946a23717"
const url = "https://www.lefisc.com.br/api/apiTv"

export default{   
    postFavorito(str){
        return axios
        .post(`https://www.lefisc.com.br/api/homeLefisc/Favorito`,str)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    }, 
    getCategEstado(){
        return axios
        .get(`${url}/TodasCategorias/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    getTodas(){
        return axios
        .get(`${url}/Ultimas/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    porCategoriaUltimas(categoria){
        return axios
        .get(`${url}/PorCategoriaUltimas/${categoria}/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    porCategoriaMaisAcessadas(categoria){
        return axios
        .get(`${url}/PorCategoriaMaisAcessadas/${categoria}/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    todasMaisAcessadas(){
        return axios
        .get(`${url}/TodasMaisAcessadas/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    porPalavra(palavra){
        return axios
        .get(`${url}/PorPalavra/${palavra}/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    todasMaisAcessadaPorPalavra(palavra){
        return axios
        .get(`${url}/TodasMaisAcessadaPorPalavra/${palavra}/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    ultimasPorPalavra(palavra){
        return axios
        .get(`${url}/UltimasPorPalavra/${palavra}/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    porCategoriaUltimasPorPalavra(categoria,palavra){
        return axios
        .get(`${url}/PorCategoriaUltimasPorPalavra/${categoria}/${palavra}/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    porCategoriaMaisAcessadasPorPalavra(categoria,palavra){
        return axios
        .get(`${url}/PorCategoriaMaisAcessadasPorPalavra/${categoria}/${palavra}/${token}`)
        .then(res=> res.data)
        .catch(err=>err.response)
    },
    Add1visualizacao(visu,idTv){
        return axios
        .post(`${url}/Add1visualizacao/${visu}/${idTv}/${token}`,
        {"visualizacoes":visu,
        "idTv":idTv})
        .then(res=> res.data)
        .catch(err=>err.response)
    }

}